export const LOGIN_PATH = "/oauth/token";
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const PASSWORD_GRANT_TYPE = "password";
export const CLIENT_CREDETIONAL_GRANT_TYPE = "client_credentials";
export const REFRESH_TOKEN_GRANT_TYPE = "refresh_token";

export const USERNAME = "guest";
export const PASSWORD = "guest12345";
